import React, { Component } from 'react'
import IconButton from '@material-ui/core/IconButton'
import PlayIcon from '@material-ui/icons/PlayCircleFilled'
import StopIcon from '@material-ui/icons/Stop'
import KeyboardRightIcon from '@material-ui/icons/KeyboardArrowRight'
import KeyboardLeftIcon from '@material-ui/icons/KeyboardArrowLeft'
import KeyboardUpIcon from '@material-ui/icons/KeyboardArrowUp'
import KeyboardDownIcon from '@material-ui/icons/KeyboardArrowDown'

import TextField from '@material-ui/core/TextField'
//import Gamepad from "../dashboard/Gamepad";
//import Sets from '../shared/Sets';
import Button from '@material-ui/core/Button'
import { Container } from '@material-ui/core'
import GamepadReact from '../gamepad/GamepadReact'
import './PlayWords.scss'
import ClickNHold from 'react-click-n-hold'

var msg = new SpeechSynthesisUtterance()
var spanishSpeechSynthesisUtterance = new SpeechSynthesisUtterance()
var germanSpeechSynthesisUtterance = new SpeechSynthesisUtterance()
var englishSpeechSynthesisUtterance = new SpeechSynthesisUtterance()
var frenchSpeechSynthesisUtterance = new SpeechSynthesisUtterance()

let mar = true
let G_timer
let Timer_Between_Words
let AllWordsPlayed
// const sleep1 = (milliseconds) => {
//     return new Promise(resolve => setTimeout(resolve, milliseconds))
//   }

var spa_found = false
var G_spanish_voice = ''

var Text_Auto_Play = ''
var Voice_Auto_Play
//var Position_Auto_Play = 8;
var Position_Auto_Play = 1
var Repetition_French = 0
var Speak_Explicit = false
var multiple_up_arrow_press = 0

// function GerSpanishVoice() {
//   var voices = speechSynthesis.getVoices();
//   voices.forEach(function(voice, i) {
//     if (voice.name.toLowerCase().indexOf("mex") != -1) {
//       G_spanish_voice = voice.name;
//       spa_found = true;
//     } else if (voice.name.toLowerCase().indexOf("span") != -1 && !spa_found) {
//       G_spanish_voice = voice.name;
//     }
//   });
// }

//var android = false;
var ua = navigator.userAgent.toLowerCase()
var isAndroid = ua.indexOf('android') > -1 //&& ua.indexOf("mobile");
// if(isAndroid) {
//   // Do something!
// }

var Util = {}
Util.base64 = function (mimeType, base64) {
  return 'data:' + mimeType + ';base64,' + base64
}

var video = document.createElement('video')
video.setAttribute('loop', '')

function addSourceToVideo(element, type, dataURI) {
  var source = document.createElement('source')
  source.src = dataURI
  source.type = 'video/' + type
  element.appendChild(source)
}

addSourceToVideo(
  video,
  'webm',
  Util.base64(
    'video/webm',
    'GkXfo0AgQoaBAUL3gQFC8oEEQvOBCEKCQAR3ZWJtQoeBAkKFgQIYU4BnQI0VSalmQCgq17FAAw9CQE2AQAZ3aGFtbXlXQUAGd2hhbW15RIlACECPQAAAAAAAFlSua0AxrkAu14EBY8WBAZyBACK1nEADdW5khkAFVl9WUDglhohAA1ZQOIOBAeBABrCBCLqBCB9DtnVAIueBAKNAHIEAAIAwAQCdASoIAAgAAUAmJaQAA3AA/vz0AAA='
  )
)
addSourceToVideo(
  video,
  'mp4',
  Util.base64(
    'video/mp4',
    'AAAAHGZ0eXBpc29tAAACAGlzb21pc28ybXA0MQAAAAhmcmVlAAAAG21kYXQAAAGzABAHAAABthADAowdbb9/AAAC6W1vb3YAAABsbXZoZAAAAAB8JbCAfCWwgAAAA+gAAAAAAAEAAAEAAAAAAAAAAAAAAAABAAAAAAAAAAAAAAAAAAAAAQAAAAAAAAAAAAAAAAAAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIAAAIVdHJhawAAAFx0a2hkAAAAD3wlsIB8JbCAAAAAAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABAAAAAAAAAAAAAAAAAAAAAQAAAAAAAAAAAAAAAAAAQAAAAAAIAAAACAAAAAABsW1kaWEAAAAgbWRoZAAAAAB8JbCAfCWwgAAAA+gAAAAAVcQAAAAAAC1oZGxyAAAAAAAAAAB2aWRlAAAAAAAAAAAAAAAAVmlkZW9IYW5kbGVyAAAAAVxtaW5mAAAAFHZtaGQAAAABAAAAAAAAAAAAAAAkZGluZgAAABxkcmVmAAAAAAAAAAEAAAAMdXJsIAAAAAEAAAEcc3RibAAAALhzdHNkAAAAAAAAAAEAAACobXA0dgAAAAAAAAABAAAAAAAAAAAAAAAAAAAAAAAIAAgASAAAAEgAAAAAAAAAAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABj//wAAAFJlc2RzAAAAAANEAAEABDwgEQAAAAADDUAAAAAABS0AAAGwAQAAAbWJEwAAAQAAAAEgAMSNiB9FAEQBFGMAAAGyTGF2YzUyLjg3LjQGAQIAAAAYc3R0cwAAAAAAAAABAAAAAQAAAAAAAAAcc3RzYwAAAAAAAAABAAAAAQAAAAEAAAABAAAAFHN0c3oAAAAAAAAAEwAAAAEAAAAUc3RjbwAAAAAAAAABAAAALAAAAGB1ZHRhAAAAWG1ldGEAAAAAAAAAIWhkbHIAAAAAAAAAAG1kaXJhcHBsAAAAAAAAAAAAAAAAK2lsc3QAAAAjqXRvbwAAABtkYXRhAAAAAQAAAABMYXZmNTIuNzguMw=='
  )
)

export class PlayWords extends Component {
  state = {
    playON: false,
    AllWordsPlayed: true,
    currentWordId: 0,
    Verzug: 3,
    settings_verbs: [],
    voices: [],
  }

  onPlayclick = () => {
    var newplayON = true
    if (this.state.playON) {
      newplayON = false
    }

    this.setState({
      playON: newplayON,
    })
    if (newplayON) {
      // AllWordsPlayed = true;
      this.setState({
        AllWordsPlayed: true,
      })
      this.SpeakText(this.props.words[0].Language1)
      // this.process_next_word(true);
    } else {
      speechSynthesis.cancel()
    }
    if (isAndroid) {
      // alert('android')
      video.play()
    }
  }

  Sleep = (milliseconds) => {
    var start = new Date().getTime()
    for (var i = 0; i < 1e7; i++) {
      if (new Date().getTime() - start > milliseconds) {
        break
      }
    }
    alert('sadasd')
  }

  componentWillMount() {
    //  console.log(this.state.voices);
    const voiceschanged = () => {
      // console.log(`Voices #: ${speechSynthesis.getVoices().length}`);
      //   speechSynthesis.getVoices().forEach(voice => {
      //   //  console.log(voice.name, voice.lang);
      //   });
      //alert("as");
      let voi = speechSynthesis.getVoices()

      // // let spanishSSSU = new SpeechSynthesisUtterance();
      // let sp_voi = voi.filter(voice => /es/.test(voice.lang))[0];
      // spanishSpeechSynthesisUtterance.voice = sp_voi;
      // spanishSpeechSynthesisUtterance.lang = sp_voi.lang;
      // spanishSpeechSynthesisUtterance.default = false;
      // spanishSpeechSynthesisUtterance.rate = 3;
      // //  spanishSpeechSynthesisUtterance = spanishSSSU;

      // //let frenchSSSU = new SpeechSynthesisUtterance();
      // sp_voi = voi.filter(voice => /fr/.test(voice.lang))[0];
      // frenchSpeechSynthesisUtterance.voice = sp_voi;
      // frenchSpeechSynthesisUtterance.lang = sp_voi.lang;
      // frenchSpeechSynthesisUtterance.default = false;
      // frenchSpeechSynthesisUtterance.rate = 3;
      // //frenchSpeechSynthesisUtterance=frenchSSSU;

      // // let englishSSSU = new SpeechSynthesisUtterance();
      // sp_voi = voi.filter(voice => /en/.test(voice.lang))[0];
      // englishSpeechSynthesisUtterance.voice = sp_voi;
      // englishSpeechSynthesisUtterance.lang = sp_voi.lang;
      // englishSpeechSynthesisUtterance.default = false;
      // englishSpeechSynthesisUtterance.rate = 3;
      // //englishSpeechSynthesisUtterance=englishSSSU;

      // //  let germanSSSU = new SpeechSynthesisUtterance();
      // sp_voi = voi.filter(voice => /de/.test(voice.lang))[0];
      // germanSpeechSynthesisUtterance.voice = sp_voi;
      // germanSpeechSynthesisUtterance.lang = sp_voi.lang;
      // germanSpeechSynthesisUtterance.default = false;
      // germanSpeechSynthesisUtterance.rate = 3;
      // //germanSpeechSynthesisUtterance = germanSSSU;
      //console.log(voi);
      this.setState({
        voices: voi,
        // spanishSpeechSynthesisUtterance:spanishSSSU,
        // frenchSpeechSynthesisUtterance:frenchSSSU,
        // englishSpeechSynthesisUtterance:englishSSSU,
        // germanSpeechSynthesisUtterance:germanSSSU
      })
    }
    // speechSynthesis.onvoiceschanged=undefined;
    //speechSynthesis.onvoiceschanged = voiceschanged;
    voiceschanged()
    if (speechSynthesis.onvoiceschanged !== undefined) {
      speechSynthesis.onvoiceschanged = voiceschanged
    }
  }

  componentDidMount() {
    // document.getElementById('voice');  MySpeakText
    var classname = document.getElementsByClassName('MySpeakText')

    var myFunction = function () {
      //   var attribute = this.getAttribute("data-myattribute");
      alert('as')
    }

    for (var i = 0; i < classname.length; i++) {
      alert('as')
      classname[i].addEventListener('click', myFunction, false)
    }

    document.addEventListener(
      'keydown',
      (event) => {
        const keyName = event.key
        if (keyName == 'ArrowRight') {
          this.GamepadPressed('right')
        } else if (keyName == 'ArrowLeft') {
          this.GamepadPressed('left')
        } else if (keyName == 'ArrowDown') {
          this.GamepadPressed('down')
          // this.GamepadPressed("DisableFilterByLevel");
        } else if (keyName == 'ArrowUp') {
          this.GamepadPressed('up')
          //  this.GamepadPressed("FilterByLevel");
          //   this.GamepadPressed("FindByLevelUp");
        }
      },
      false
    )
  }

  NextWordNoAuto = () => {
    // speechSynthesis.cancel()
  if(this.props.autoPlaySettings.SpeakOnNavigation && this.SpeakAdditionlLanguage()){
     setTimeout(this.GamepadPressed, 1500, 'right')
   }
   else{
    this.GamepadPressed('right')
   }
    //this.GamepadPressed('right')

    // setTimeout(function () {
    //   this.GamepadPressed('right')
    // }, 1500)
  }

  SpeakAdditionlLanguage = () => {
    console.log(this.props.autoPlaySettings)
    let voice
    let text_speak
    let propobj = this.props.words[this.state.currentWordId]
    let autoPlaySettings = this.props.autoPlaySettings

    if (autoPlaySettings.Language1) {
      text_speak = propobj.Language1
      voice = this.props.settingSpeak.SpanishVoice
    }
    if (autoPlaySettings.Language2) {
      text_speak = propobj.Language2
      voice = this.props.settingSpeak.GermanVoice
    }
    if (autoPlaySettings.Language3) {
      text_speak = propobj.Language3
      voice = this.props.settingSpeak.EnglishVoice
    }
    if (autoPlaySettings.Language4) {
      text_speak = propobj.Language4
      voice = this.props.settingSpeak.FrenchVoice
    }
    if (autoPlaySettings.Description1) {
      text_speak = propobj.Description1
      voice = this.props.settingSpeak.SpanishVoice
    }
    if (autoPlaySettings.Description2) {
      text_speak = propobj.Description2
      voice = this.props.settingSpeak.GermanVoice
    }
    if (autoPlaySettings.Description3) {
      text_speak = propobj.Description3
      voice = this.props.settingSpeak.EnglishVoice
    }
    if (autoPlaySettings.Description4) {
      text_speak = propobj.Description4
      voice = this.props.settingSpeak.FrenchVoice
    }
    if(text_speak){
      this.SpeakText(text_speak, voice)
      return true
    }
    return false
  
  }

  ReadAll = () => {
    this.ReadFrench()
    setTimeout(this.ReadGerman, 500)
    //his.ReadGerman()
  }

  ReadFrench = () => {
    let voice
    let text_speak
    text_speak = this.props.words[this.state.currentWordId].Language4
    voice = this.props.settingSpeak.FrenchVoice
    this.SpeakText(text_speak, voice)
  }

  ReadGerman = () => {
    let voice
    let text_speak
    text_speak = this.props.words[this.state.currentWordId].Language2
    voice = this.props.settingSpeak.GermanVoice
    this.SpeakText(text_speak, voice)
  }

  GamepadPressed = (g_command) => {
    console.log(g_command)
    //  alert("right");
    let voice
    let text_speak
    speechSynthesis.cancel()
    if (g_command == 'right') {
      let id = this.process_next_word(true)
      if (
        this.props.settingSpeak.Right == 'Language2' ||
        this.props.settingSpeak.Right == 'Description2'
      ) {
        voice = this.props.settingSpeak.GermanVoice
      } else if (
        this.props.settingSpeak.Right == 'Language3' ||
        this.props.settingSpeak.Right == 'Description3'
      ) {
        voice = this.props.settingSpeak.EnglishVoice
      } else if (
        this.props.settingSpeak.Right == 'Language4' ||
        this.props.settingSpeak.Right == 'Description4'
      ) {
        voice = this.props.settingSpeak.FrenchVoice
      } else if (
        this.props.settingSpeak.Right == 'Language5' ||
        this.props.settingSpeak.Right == 'Description5'
      ) {
        voice = this.props.settingSpeak.ItalianVoice
      } else {
        voice = this.props.settingSpeak.SpanishVoice
      }
      if (voice == '') {
        voice = this.props.settingSpeak.EnglishVoice
      }
      text_speak = this.props.words[id][this.props.settingSpeak.Right]
      if (text_speak == '') {
        text_speak = this.props.words[id].Language3
        voice = this.props.settingSpeak.EnglishVoice
      }
      if (text_speak != '') {
        this.SpeakText(text_speak, voice)
      }
    }
    if (g_command == 'left') {
      let id = this.process_next_word(false)
      if (
        this.props.settingSpeak.Left == 'Language2' ||
        this.props.settingSpeak.Left == 'Description2'
      ) {
        voice = this.props.settingSpeak.GermanVoice
      } else if (
        this.props.settingSpeak.Left == 'Language3' ||
        this.props.settingSpeak.Left == 'Description3'
      ) {
        voice = this.props.settingSpeak.EnglishVoice
      } else if (
        this.props.settingSpeak.Left == 'Language4' ||
        this.props.settingSpeak.Left == 'Description4'
      ) {
        voice = this.props.settingSpeak.FrenchVoice
      } else if (
        this.props.settingSpeak.Left == 'Language5' ||
        this.props.settingSpeak.Left == 'Description5'
      ) {
        voice = this.props.settingSpeak.ItalianVoice
      } else {
        voice = this.props.settingSpeak.SpanishVoice
      }
      if (voice == '') {
        voice = this.props.settingSpeak.EnglishVoice
      }
      //  this.SpeakText(this.props.words[this.state.currentWordId][this.props.settingSpeak.Left],voice);
      text_speak = this.props.words[id][this.props.settingSpeak.Left]
      if (text_speak == '') {
        text_speak = this.props.words[id].Language3
        voice = this.props.settingSpeak.EnglishVoice
      }
      if (text_speak != '') {
        this.SpeakText(text_speak, voice)
      }
    }
    if (g_command == 'up') {
      let Up = this.props.settingSpeak.Up
      // if(multiple_up_arrow_press>0)
      // {
      //     if(multiple_up_arrow_press==2){
      //         multiple_up_arrow_press=4;
      //     }
      //     if(multiple_up_arrow_press==3){
      //         multiple_up_arrow_press=4;
      //     }
      //     if(multiple_up_arrow_press>4){
      //         multiple_up_arrow_press=1;
      //     }
      //     Up="Language"+multiple_up_arrow_press.toString();

      // }
      if (Up == 'Language2' || Up == 'Description2') {
        voice = this.props.settingSpeak.GermanVoice
      } else if (Up == 'Language3' || Up == 'Description3') {
        voice = this.props.settingSpeak.EnglishVoice
      } else if (Up == 'Language4' || Up == 'Description4') {
        voice = this.props.settingSpeak.FrenchVoice
      } else if (Up == 'Language5' || Up == 'Description5') {
        voice = this.props.settingSpeak.ItalianVoice
      } else {
        voice = this.props.settingSpeak.SpanishVoice
      }
      if (voice == '') {
        voice = this.props.settingSpeak.EnglishVoice
      }
      // this.SpeakText(this.props.words[this.state.currentWordId][this.props.settingSpeak.Up],voice);
      text_speak = this.props.words[this.state.currentWordId][Up]
      if (text_speak == '') {
        text_speak = this.props.words[this.state.currentWordId].Language3
        voice = this.props.settingSpeak.EnglishVoice
      }
      if (text_speak != '') {
        this.SpeakText(text_speak, voice)
      }
      //  multiple_up_arrow_press++;
    }
    if (g_command == 'down') {
      if (
        this.props.settingSpeak.Down == 'Language2' ||
        this.props.settingSpeak.Down == 'Description2'
      ) {
        voice = this.props.settingSpeak.GermanVoice
      } else if (
        this.props.settingSpeak.Down == 'Language3' ||
        this.props.settingSpeak.Down == 'Description3'
      ) {
        voice = this.props.settingSpeak.EnglishVoice
      } else if (
        this.props.settingSpeak.Down == 'Language4' ||
        this.props.settingSpeak.Down == 'Description4'
      ) {
        voice = this.props.settingSpeak.FrenchVoice
      } else if (
        this.props.settingSpeak.Down == 'Language5' ||
        this.props.settingSpeak.Down == 'Description5'
      ) {
        voice = this.props.settingSpeak.ItalianVoice
      } else {
        voice = this.props.settingSpeak.SpanishVoice
      }
      if (voice == '') {
        voice = this.props.settingSpeak.EnglishVoice
      }
      // this.SpeakText(this.props.words[this.state.currentWordId][this.props.settingSpeak.Down],voice);
      text_speak =
        this.props.words[this.state.currentWordId][this.props.settingSpeak.Down]
      if (text_speak == '') {
        text_speak = this.props.words[this.state.currentWordId].Language3
        voice = this.props.settingSpeak.EnglishVoice
      }
      if (text_speak != '') {
        this.SpeakText(text_speak, voice)
      }
    }
    if (g_command == 'X') {
      if (
        this.props.settingSpeak.X == 'Language2' ||
        this.props.settingSpeak.X == 'Description2'
      ) {
        voice = this.props.settingSpeak.GermanVoice
      } else if (
        this.props.settingSpeak.X == 'Language3' ||
        this.props.settingSpeak.X == 'Description3'
      ) {
        voice = this.props.settingSpeak.EnglishVoice
      } else if (
        this.props.settingSpeak.X == 'Language4' ||
        this.props.settingSpeak.X == 'Description4'
      ) {
        voice = this.props.settingSpeak.FrenchVoice
      } else if (
        this.props.settingSpeak.X == 'Language5' ||
        this.props.settingSpeak.X == 'Description5'
      ) {
        voice = this.props.settingSpeak.ItalianVoice
      } else {
        voice = this.props.settingSpeak.SpanishVoice
      }
      if (voice == '') {
        voice = this.props.settingSpeak.EnglishVoice
      }
      text_speak =
        this.props.words[this.state.currentWordId][this.props.settingSpeak.X]
      if (text_speak == '') {
        text_speak = this.props.words[this.state.currentWordId].Description3
        voice = this.props.settingSpeak.EnglishVoice
      }
      if (text_speak != '') {
        this.SpeakText(text_speak, voice)
      }
    }
    if (g_command == 'Y') {
      //   alert("Y");
      if (
        this.props.settingSpeak.Y == 'Language2' ||
        this.props.settingSpeak.Y == 'Description2'
      ) {
        voice = this.props.settingSpeak.GermanVoice
      } else if (
        this.props.settingSpeak.Y == 'Language3' ||
        this.props.settingSpeak.Y == 'Description3'
      ) {
        voice = this.props.settingSpeak.EnglishVoice
      } else if (
        this.props.settingSpeak.Y == 'Language4' ||
        this.props.settingSpeak.Y == 'Description4'
      ) {
        voice = this.props.settingSpeak.FrenchVoice
      } else if (
        this.props.settingSpeak.Y == 'Language5' ||
        this.props.settingSpeak.Y == 'Description5'
      ) {
        voice = this.props.settingSpeak.ItalianVoice
      } else {
        voice = this.props.settingSpeak.SpanishVoice
      }
      if (voice == '') {
        voice = this.props.settingSpeak.EnglishVoice
      }
      text_speak =
        this.props.words[this.state.currentWordId][this.props.settingSpeak.Y]
      if (text_speak == '') {
        text_speak = this.props.words[this.state.currentWordId].Description3
        voice = this.props.settingSpeak.EnglishVoice
      }
      if (text_speak != '') {
        this.SpeakText(text_speak, voice)
      }
    }

    if (g_command == 'A') {
      //   alert("Y");
      if (
        this.props.settingSpeak.A == 'Language2' ||
        this.props.settingSpeak.A == 'Description2'
      ) {
        voice = this.props.settingSpeak.GermanVoice
      } else if (
        this.props.settingSpeak.A == 'Language3' ||
        this.props.settingSpeak.A == 'Description3'
      ) {
        voice = this.props.settingSpeak.EnglishVoice
      } else if (
        this.props.settingSpeak.A == 'Language4' ||
        this.props.settingSpeak.A == 'Description4'
      ) {
        voice = this.props.settingSpeak.FrenchVoice
      } else if (
        this.props.settingSpeak.A == 'Language5' ||
        this.props.settingSpeak.A == 'Description5'
      ) {
        voice = this.props.settingSpeak.ItalianVoice
      } else {
        voice = this.props.settingSpeak.SpanishVoice
      }
      if (voice == '') {
        voice = this.props.settingSpeak.EnglishVoice
      }
      text_speak =
        this.props.words[this.state.currentWordId][this.props.settingSpeak.A]
      if (text_speak == '') {
        text_speak = this.props.words[this.state.currentWordId].Description3
        voice = this.props.settingSpeak.EnglishVoice
      }
      if (text_speak != '') {
        this.SpeakText(text_speak, voice)
      }
    }

    if (g_command == 'B') {
      //   alert("Y");
      if (
        this.props.settingSpeak.B == 'Language2' ||
        this.props.settingSpeak.B == 'Description2'
      ) {
        voice = this.props.settingSpeak.GermanVoice
      } else if (
        this.props.settingSpeak.B == 'Language3' ||
        this.props.settingSpeak.B == 'Description3'
      ) {
        voice = this.props.settingSpeak.EnglishVoice
      } else if (
        this.props.settingSpeak.B == 'Language4' ||
        this.props.settingSpeak.B == 'Description4'
      ) {
        voice = this.props.settingSpeak.FrenchVoice
      } else if (
        this.props.settingSpeak.B == 'Language5' ||
        this.props.settingSpeak.B == 'Description5'
      ) {
        voice = this.props.settingSpeak.ItalianVoice
      } else {
        voice = this.props.settingSpeak.SpanishVoice
      }
      if (voice == '') {
        voice = this.props.settingSpeak.EnglishVoice
      }
      text_speak =
        this.props.words[this.state.currentWordId][this.props.settingSpeak.B]
      if (text_speak == '') {
        text_speak = this.props.words[this.state.currentWordId].Description3
        voice = this.props.settingSpeak.EnglishVoice
      }
      if (text_speak != '') {
        this.SpeakText(text_speak, voice)
      }
    }

    // if (g_command == 'L') {
    //   multiple_up_arrow_press++;
    //   let Up = this.props.settingSpeak.Up;
    //   if (multiple_up_arrow_press > 0) {
    //     if (multiple_up_arrow_press == 2) {
    //       multiple_up_arrow_press = 4;
    //     }
    //     if (multiple_up_arrow_press == 3) {
    //       multiple_up_arrow_press = 4;
    //     }
    //     if (multiple_up_arrow_press > 4) {
    //       multiple_up_arrow_press = 1;
    //     }
    //     Up = 'Language' + multiple_up_arrow_press.toString();
    //   }
    //   if (Up == 'Language2' || Up == 'Description2') {
    //     voice = this.props.settingSpeak.GermanVoice;
    //   } else if (Up == 'Language3' || Up == 'Description3') {
    //     voice = this.props.settingSpeak.EnglishVoice;
    //   } else if (Up == 'Language4' || Up == 'Description4') {
    //     voice = this.props.settingSpeak.FrenchVoice;
    //   } else if (Up == 'Language5' || Up == 'Description5') {
    //     voice = this.props.settingSpeak.ItalianVoice;
    //   } else {
    //     voice = this.props.settingSpeak.SpanishVoice;
    //   }
    //   if (voice == '') {
    //     voice = this.props.settingSpeak.EnglishVoice;
    //   }
    //   // this.SpeakText(this.props.words[this.state.currentWordId][this.props.settingSpeak.Up],voice);
    //   text_speak = this.props.words[this.state.currentWordId][Up];
    //   if (text_speak == '') {
    //     text_speak = this.props.words[this.state.currentWordId].Language3;
    //     voice = this.props.settingSpeak.EnglishVoice;
    //   }
    //   if (text_speak != '') {
    //     this.SpeakText(text_speak, voice);
    //   }
    // }
    if (g_command == 'L') {
      this.props.ChangeDate()
      this.SpeakText('Date changed', voice)
    }
    if (g_command == 'R') {
      voice = this.props.settingSpeak.EnglishVoice
      var level = this.props.words[this.state.currentWordId].level + 1
      if (level > 7) {
        level = 1
      }
      this.SpeakText(level.toString(), voice)
      this.props.ClickLevel()
    }

    if (g_command == 'FindByLevelUp') {
      var level = this.props.words[this.state.currentWordId].level + 1
      if (level > 7) {
        level = 1
      }
      voice = this.props.settingSpeak.EnglishVoice
      this.SpeakText('Find By Level ' + level.toString(), voice)
      this.props.FindByLevel(level)
    }
    if (g_command == 'FindByLevelDown') {
      var level = this.props.words[this.state.currentWordId].level - 1
      if (level < 2) {
        level = 5
      }
      voice = this.props.settingSpeak.EnglishVoice
      this.SpeakText('Find By Level ' + level.toString(), voice)
      this.props.FindByLevel(level)
    }

    if (g_command == 'Start') {
      if (
        this.props.settingSpeak.Start == 'Language2' ||
        this.props.settingSpeak.Start == 'Description2'
      ) {
        voice = this.props.settingSpeak.GermanVoice
      } else if (
        this.props.settingSpeak.Start == 'Language3' ||
        this.props.settingSpeak.Start == 'Description3'
      ) {
        voice = this.props.settingSpeak.EnglishVoice
      } else if (
        this.props.settingSpeak.Start == 'Language4' ||
        this.props.settingSpeak.Start == 'Description4'
      ) {
        voice = this.props.settingSpeak.FrenchVoice
      } else if (
        this.props.settingSpeak.Start == 'Language5' ||
        this.props.settingSpeak.Start == 'Description5'
      ) {
        voice = this.props.settingSpeak.ItalianVoice
      } else {
        voice = this.props.settingSpeak.SpanishVoice
      }
      if (voice == '') {
        voice = this.props.settingSpeak.EnglishVoice
      }
      // this.SpeakText(this.props.words[this.state.currentWordId][this.props.settingSpeak.Down],voice);
      text_speak =
        this.props.words[this.state.currentWordId][
          this.props.settingSpeak.Start
        ]
      if (text_speak == '') {
        text_speak = this.props.words[this.state.currentWordId].Language3
        voice = this.props.settingSpeak.EnglishVoice
      }
      if (text_speak != '') {
        this.SpeakText(text_speak, voice)
      }
    }

    if (g_command == 'bookmark') {
      this.props.handleBookmark(true)
      this.SpeakText('Bookmarked!', this.props.settingSpeak.SpanishVoice)
    }

    if (g_command == 'levelup') {
      voice = this.props.settingSpeak.EnglishVoice

      var level = this.props.words[this.state.currentWordId].level + 1
      if (level > 7) {
        level = 1
      }
      this.SpeakText(level.toString(), voice)
      this.props.ClickLevel()
    }

    if (g_command == 'FilterByLevel') {
      voice = this.props.settingSpeak.EnglishVoice
      this.SpeakText('Filter By Level', voice)
      this.props.FilterByLevel(2)
    }
    if (g_command == 'DisableFilterByLevel') {
      voice = this.props.settingSpeak.EnglishVoice
      this.SpeakText('Disable Filter By Level', voice)
      this.props.RefreshOriginalWords()
    }

    if (g_command == 'Select') {
      if (
        this.props.settingSpeak.Select == 'Language2' ||
        this.props.settingSpeak.Select == 'Description2'
      ) {
        voice = this.props.settingSpeak.GermanVoice
      } else if (
        this.props.settingSpeak.Select == 'Language3' ||
        this.props.settingSpeak.Select == 'Description3'
      ) {
        voice = this.props.settingSpeak.EnglishVoice
      } else if (
        this.props.settingSpeak.Select == 'Language4' ||
        this.props.settingSpeak.Select == 'Description4'
      ) {
        voice = this.props.settingSpeak.FrenchVoice
      } else if (
        this.props.settingSpeak.Select == 'Language5' ||
        this.props.settingSpeak.Select == 'Description5'
      ) {
        voice = this.props.settingSpeak.ItalianVoice
      } else {
        voice = this.props.settingSpeak.SpanishVoice
      }
      if (voice == '') {
        voice = this.props.settingSpeak.EnglishVoice
      }
      // this.SpeakText(this.props.words[this.state.currentWordId][this.props.settingSpeak.Down],voice);
      text_speak =
        this.props.words[this.state.currentWordId][
          this.props.settingSpeak.Select
        ]
      if (text_speak == '') {
        text_speak = this.props.words[this.state.currentWordId].Language3
        voice = this.props.settingSpeak.EnglishVoice
      }
      if (text_speak != '') {
        this.SpeakText(text_speak, voice)
      }
    }
  }

  process_next_word = (ascending) => {
    multiple_up_arrow_press = 0

    clearInterval(G_timer)
    let id
    if (ascending) {
      id = this.state.currentWordId + 1
      if (id >= this.props.words.length) {
        id = 0
      }
    } else {
      id = this.state.currentWordId - 1
      if (id < 0) {
        id = this.props.words.length - 1
      }
    }

    if (id < this.props.words.length) {
      if (this.props.words[id].Language1 != '') {
        //  NextSubVerb();
      }
Speak_Explicit = false
      this.setState({
        currentWordId: id,
      })
      this.props.changeCurrentID(id)
    }
    return id
  }

  SpeakText = (text, passvoice) => {
    //   var voices = window.speechSynthesis.getVoices();
    var Play = this
    var new_voices

    //      if(passvoice.toLowerCase().search("spa")>-1){

    //         spanishSpeechSynthesisUtterance.text=text;
    //         speechSynthesis.speak(spanishSpeechSynthesisUtterance);

    //      }
    //      else if(passvoice.toLowerCase().search("fr")>-1){
    //   frenchSpeechSynthesisUtterance.text=text;
    //   speechSynthesis.speak(frenchSpeechSynthesisUtterance);
    //     }
    //     else if(passvoice.toLowerCase().search("ge")>-1){
    //    germanSpeechSynthesisUtterance.text=text;
    //    speechSynthesis.speak(germanSpeechSynthesisUtterance);
    //     }
    //     else if(passvoice.toLowerCase().search("en")>-1){
    //      englishSpeechSynthesisUtterance.text=text;
    //      speechSynthesis.speak(englishSpeechSynthesisUtterance);
    //     }

    if (passvoice == undefined || passvoice == '') {
      if (G_spanish_voice != '') {
        var new_voices = this.state.voices.filter(function (voice) {
          return voice.name == G_spanish_voice
        })[0]
        msg.voice = new_voices
        msg.lang = new_voices.lang
        //   msg.voice = speechSynthesis.getVoices().filter(function(voice) { return voice.name == G_spanish_voice; })[0];
      }
    } else {
      //      console.log(this.state.voices);
      var new_voices = this.state.voices.filter(function (voice) {
        return voice.name == passvoice
      })[0]
      // if(msg.lang != new_voices.lang){
      //   // speechSynthesis.cancel();
      //   // speechSynthesis.cancel();
      //   console.log("diff");
      //       }
      //       else{
      //         console.log("same");
      //       }
      msg.voice = new_voices
      msg.lang = new_voices.lang
      // alert(msg.voice);
      // alert(msg.lang);
      //  msg.voice = speechSynthesis.getVoices().filter(function(voice) { return voice.name == passvoice; })[0];
    }

    //  alert(msg.voice.name);
    //    msg.default = true;
    //  msg.rate = 2;
    // alert(Play.props.settingSpeak.Speed);
    msg.rate = Play.props.settingSpeak.Speed
    if (msg.lang.includes('fr') || msg.lang.includes('FR')) {
     // msg.rate = msg.rate - 0.5
    }
    //   msg.pitch=2;
    msg.text = text
    msg.onend = function (e) {
      if (Play.state.playON && Play.state.AllWordsPlayed) {
        //    console.log(this);
        //     G_timer = setInterval(()=>Play.NextWord(), Play.state.Verzug * 1000);
        //  console.log(Play.props.autoPlaySettings.Order);
        if (Play.props.autoPlaySettings.Order == 'Asc') {
          //   console.log("Asc");
          G_timer = setInterval(
            () => Play.NextWord(),
            Play.props.autoPlaySettings.Verzug * 1000
          )
        } else {
          //    console.log("Desc");
          G_timer = setInterval(
            () => Play.NextWordReverse(),
            Play.props.autoPlaySettings.Verzug * 1000
          )
        }
      }
    }
    //   mario 11.7.2019
    //      speechSynthesis.pause();
    //speechSynthesis.resume();
    speechSynthesis.speak(msg)
  }

  GetNextAutoWord(position) {
    let propobj = this.props.words[this.state.currentWordId]
    let autoPlaySettings = this.props.autoPlaySettings
    Text_Auto_Play = ''

    if (position == 1) {
      if (autoPlaySettings.Language1) {
        Text_Auto_Play = propobj.Language1
        Voice_Auto_Play = this.props.settingSpeak.SpanishVoice
      }
    } else if (position == 2) {
      if (autoPlaySettings.Language2) {
        Text_Auto_Play = propobj.Language2
        Voice_Auto_Play = this.props.settingSpeak.GermanVoice
      }
    } else if (position == 3) {
      if (autoPlaySettings.Language3) {
        Text_Auto_Play = propobj.Language3
        Voice_Auto_Play = this.props.settingSpeak.EnglishVoice
      }
    } else if (position == 4) {
      if (autoPlaySettings.Language4) {
        Text_Auto_Play = propobj.Language4
        Voice_Auto_Play = this.props.settingSpeak.FrenchVoice
      }
    } else if (position == 5) {
      if (autoPlaySettings.Language5) {
        Text_Auto_Play = propobj.Language5
        Voice_Auto_Play = this.props.settingSpeak.ItalianVoice
      }
    } else if (position == 6) {
      if (autoPlaySettings.Description1) {
        Text_Auto_Play = propobj.Description1
        Voice_Auto_Play = this.props.settingSpeak.SpanishVoice
      }
    } else if (position == 7) {
      if (autoPlaySettings.Description2) {
        Text_Auto_Play = propobj.Description2
        Voice_Auto_Play = this.props.settingSpeak.GermanVoice
      }
    } else if (position == 8) {
      if (autoPlaySettings.Description3) {
        Text_Auto_Play = propobj.Description3
        Voice_Auto_Play = this.props.settingSpeak.EnglishVoice
      }
    } else if (position == 9) {
      if (autoPlaySettings.Description4) {
        Text_Auto_Play = propobj.Description4
        Voice_Auto_Play = this.props.settingSpeak.FrenchVoice
      }
    } else if (position == 10) {
      if (autoPlaySettings.Description5) {
        Text_Auto_Play = propobj.Description5
        Voice_Auto_Play = this.props.settingSpeak.ItalianVoice
      }
    }

    // else{
    //     Text_Auto_Play="";
    // }
  }

  
  CheckWordSpeakBySettings() {

let propobj = this.props.words[this.state.currentWordId]
let text = ""
let voice = ""
// const speakExplicit = ["Language1"]
const speakExplicit = propobj.speakExplicit
speakExplicit.forEach(sp => {
  switch(sp) {
    case "Language1":
      text += propobj.Language1 + " . "
      voice = this.props.settingSpeak.SpanishVoice
      break;
      case "Language2":
        text += propobj.Language2 + " . "
        voice = this.props.settingSpeak.GermanVoice
        break;
        case "Language3":
          text += propobj.Language3 + " . "
          voice = this.props.settingSpeakEnglishVoice
          break;
          case "Language4":
            text += propobj.Language4 + " . "
            voice = this.props.settingSpeak.FrenchVoice
            break;
            case "Language5":
              text += propobj.Language5 + " . "
              voice = this.props.settingSpeak.ItalianVoice
              break;
              case "Description1":
                text += propobj.Description1
                voice = this.props.settingSpeak.SpanishVoice
                break;
                case "Description2":
                  text += propobj.Description2
                  voice = this.props.settingSpeak.GermanVoice
                  break;
                  case "Description3":
                    text += propobj.Description3
                    voice = this.props.settingSpeak.settingSpeakEnglishVoice
                    break;
                    case "Description4":
                      text += propobj.Description4
                      voice = this.props.settingSpeak.FrenchVoice
                      break;
                      case "Description5":
                        text += propobj.Description5
                        voice = this.props.settingSpeak.ItalianVoice
                        break;
    default:
      // code block
  }})
if(text.length){
  this.SpeakText(text, voice)
  Speak_Explicit = true
  return true
}

  return false

  }


  NextWord() {
    clearInterval(G_timer)
    if (Repetition_French > 0 && Repetition_French < 2) {
      //    Position_Auto_Play=4;
      //        alert(Repetition_French);
      this.SpeakText(Text_Auto_Play, Voice_Auto_Play)
      Repetition_French++
      return
    } else {
      Repetition_French = 0
    }

    // check word speak by settings
    if(this.props.words[this.state.currentWordId].speakExplicit &&  this.props.words[this.state.currentWordId].speakExplicit.length) {

  
    if(!Speak_Explicit && this.CheckWordSpeakBySettings()){
    return
    }
    }

    var found_text_to_speak = false
    for (var i = Position_Auto_Play; i <= 10; i++) {
      this.GetNextAutoWord(i)
      if (Text_Auto_Play != '' && Text_Auto_Play != undefined) {
        //       alert(i);
        if (i == 4) {
          if (Repetition_French <= 2) {
            Repetition_French++
          } else {
          }
        } else {
        }
        Position_Auto_Play = i + 1
        found_text_to_speak = true
        break
      }
    }
    if (found_text_to_speak) {
      this.SpeakText(Text_Auto_Play, Voice_Auto_Play)
    } else {
      this.process_next_word(true)
      Text_Auto_Play = ''
      Position_Auto_Play = 1
      this.NextWord()
    }
  }

  NextWordReverse() {
    clearInterval(G_timer)
    var found_text_to_speak = false
    for (var i = Position_Auto_Play; i >= 1; i--) {
      this.GetNextAutoWord(i)
      if (Text_Auto_Play != '' && Text_Auto_Play != undefined) {
        found_text_to_speak = true
        Position_Auto_Play = i - 1
        break
      }
    }
    if (found_text_to_speak) {
      this.SpeakText(Text_Auto_Play, Voice_Auto_Play)
    } else {
      this.process_next_word(true)
      Text_Auto_Play = ''
      Position_Auto_Play = 10
      this.NextWordReverse()
    }
  }

  handleChange = (e) => {
    this.setState({
      [e.target.id]: e.target.value,
    })
  }

  speakDivClick = (e) => {
    speechSynthesis.cancel()
    this.SpeakText(
      document.getElementById('speakdiv').innerHTML,
      this.props.settingSpeak[document.getElementById('voicediv').innerHTML]
    )
    //alert(this.props.settingSpeak[document.getElementById('voicediv').innerHTML]);
  }

  render() {
    // GerSpanishVoice();

    return (
      <div className='play-words'>
        {/* <Gamepad GamepadPressed={this.GamepadPressed}></Gamepad> */}
        <GamepadReact GamepadPressed={this.GamepadPressed}></GamepadReact>
        {/* <Button
          onClick={() => this.GamepadPressed('up')}
          className="left1-margin-button"
          color="secondary"
        >
          <KeyboardUpIcon></KeyboardUpIcon>
        </Button> */}
        <section className="buttons">
          <div className='buttons-left'>
          <Button
            className="btn-play play-button"
            onClick={() => this.onPlayclick()}
            aria-label="Edit"
          >
            {this.state.playON ? <StopIcon /> : <PlayIcon />}
          </Button>
          <Button
            className="btn-left play-button"
            onClick={() => this.GamepadPressed('left')}
            color="secondary"
          >
            <KeyboardLeftIcon></KeyboardLeftIcon>
          </Button>


          </div>
          {/* <Button
            className="btn-right"
            onClick={() => this.GamepadPressed('right')}
            color="secondary"
          >
            <KeyboardRightIcon></KeyboardRightIcon>
          </Button> */}
          <ClickNHold
            className="hold play-button"
            time={0.5} // Time to keep pressing. Default is 2
            onStart={() => {
              let zz = 0
            }} // Start callback
            onClickNHold={this.ReadAll} //Timeout callback
            onEnd={() => {
              let yy = 0
            }}
          >
            <Button
              className="btn-right"
              onClick={() => this.NextWordNoAuto()}
              color="secondary"
            >
              <KeyboardRightIcon></KeyboardRightIcon>
            </Button>
          </ClickNHold>
        </section>
        {/* <Button
          onClick={() => this.GamepadPressed('down')}
          className="left1-margin-button"
          color="secondary"
        >
          <KeyboardDownIcon></KeyboardDownIcon>
        </Button> */}

        <br></br>
        <div hidden id="speakdiv" onClick={() => this.speakDivClick()}></div>
        <div hidden id="voicediv"></div>

        {/* <TextField fullWidth 
                        id="Verzug"
                        label="Verzug"
                        className="Verzug"
                        value={this.state.Verzug}
                        onChange={this.handleChange}
                        margin="normal"
                        max-width="100px"
                        /> */}
      </div>
    )
  }
}

export default PlayWords
